import { useNavigate } from 'react-router-dom';
import { Body, Child, Container, StyledButton, Title } from '../components';
import { privacy } from '../text';

export const Privacy = () => {
	const navigate = useNavigate();
	return (
		<Container container>
			<Child>
				<Title>{privacy.title}</Title>
			</Child>
			<Child>
				<Body>{privacy.body}</Body>
			</Child>
			<Child container justify="center">
				<StyledButton onClick={() => navigate(-1)}>BACK</StyledButton>
			</Child>
		</Container>
	);
};
